export default "__VITE_ASSET__02df28f4__"